module.exports = __webpack_public_path__ + "images/hint-776b2a.svg";